<template>
  <div class="table-components">
    <!-- 搜索框 -->
    <div class="customitem">
      <div>
        <el-form inline>
          <span v-for="(item, index) in searchData.search" :key="index">
            <template v-if="!item.hide">
              <el-form-item :label="item.label">
                <!-- slot -->
                <template v-if="item.slot">
                  <slot :name="item.key"></slot>
                </template>

                <template v-else>
                  <el-input
                    @blur="blurFormatter(search[item.key])"
                    v-if="item.type === 'input'"
                    v-model="search[item.key]"
                    @change="inputChange($event, item)"
                    :maxlength="item.maxlength"
                    :minlength="item.minlength"
                    :show-word-limit="item.showWordLimit"
                    :disabled="item.disabled"
                    :prefix-icon="item.prefixIcon"
                    :suffix-icon="item.suffixIcon"
                    :max="item.max"
                    :min="item.min"
                    :label="item.label"
                    :tabindex="item.tabindex"
                    :validate-event="item.validateEvent"
                    :placeholder="item.placeholder || '请输入' + item.label"
                    :clearable="item.clearable"
                  ></el-input>
                  <el-select
                    v-if="item.type === 'select'"
                    :clearable="item.clearable"
                    filterable
                    v-model="filters[item.key]"
                    :multiple="item.multiple"
                    :placeholder="item.placeholder || '请选择' + item.label"
                  >
                    <el-option
                      v-for="(ops, index1) in item.options"
                      :key="index1"
                      :label="ops.label"
                      :value="ops.value"
                    ></el-option>
                  </el-select>
                  <el-date-picker
                    v-if="item.type === 'daterange'"
                    v-model="filters[item.key]"
                    type="daterange"
                    :range-separator="item.rangeSeparator || '至'"
                    :start-placeholder="item.startPlaceholder || '开始日期'"
                    :end-placeholder="item.endPlaceholder || '结束日期'"
                    :value-format="item.valueFormat || 'yyyy-MM-dd'"
                  >
                  </el-date-picker>
                </template>
              </el-form-item>
            </template>
          </span>

          <el-form-item v-if="searchData.moreSearch.length">
            <div class="more-search">
              <el-link
                :underline="false"
                @click="showMoreSearch = !showMoreSearch"
                >更多<i
                  :class="
                    showMoreSearch
                      ? 'el-icon-arrow-right re90'
                      : 'el-icon-arrow-right re0'
                  "
                ></i
              ></el-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <transition name="el-fade-in-linear" v-if="showMoreSearch">
        <div v-if="searchData.moreSearch.length" class="transition-box">
          <el-form inline>
            <span v-for="(item, index) in searchData.moreSearch" :key="index">
              <template v-if="!item.hide">
                <el-form-item :label="item.hideLabel ? '' : item.label">
                  <!-- slot -->
                  <template v-if="item.slot">
                    <slot :name="item.key"></slot>
                  </template>

                  <template v-else>
                    <el-input
                      v-if="item.type === 'input'"
                      v-model="search[item.key]"
                      :maxlength="item.maxlength"
                      :minlength="item.minlength"
                      :show-word-limit="item.showWordLimit"
                      :disabled="item.disabled"
                      :prefix-icon="item.prefixIcon"
                      :suffix-icon="item.suffixIcon"
                      :max="item.max"
                      :min="item.min"
                      :label="item.label"
                      :tabindex="item.tabindex"
                      :validate-event="item.validateEvent"
                      :placeholder="item.placeholder"
                      :clearable="item.clearable"
                    ></el-input>

                    <el-select
                      v-if="item.type === 'select'"
                      v-model="search[item.key]"
                      :multiple="item.multiple"
                      filterable
                    >
                      <el-option
                        v-for="(ops, index1) in item.options"
                        :key="index1"
                        :label="ops.label"
                        :value="ops.value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </template>
            </span>
          </el-form>
        </div>
      </transition>
    </div>

    <!-- 工具条 -->
    <tool-Bar
      :buttonList="buttonList"
      :showResetButton="tableConfig.showResetButton"
      @resetBtn="resetBtn"
      @callFunction="callFunction"
      style="margin-bottom: -10px"
    ></tool-Bar>

    <!-- tab栏 -->
    <div v-if="tableConfig.showTabBar">
      <template v-if="tableConfig.tabBarConfig.tabType === 'tab'">
        <el-tabs
          v-model="tabsLabel"
          :type="tableConfig.tabBarConfig.type || 'card'"
          @tab-click="tabsHandleClick"
        >
          <el-tab-pane
            v-for="(item, index) in tableConfig.tabBarConfig.items"
            :key="index"
            :disabled="item.disabled"
            :label="item.label"
            :name="item.label"
            ><span slot="label"
              ><i :class="item.icon"></i>{{ item.label
              }}<span v-if="item.num">({{ item.num }})</span></span
            ></el-tab-pane
          >
        </el-tabs>
      </template>
      <template v-if="tableConfig.tabBarConfig.tabType === 'radio'">
        <div style="margin-bottom: 5px">
          <el-radio-group
            v-model="tabsLabel"
            @change="tabsHandleClick"
            :size="tableConfig.tabBarConfig.radioSize || 'small'"
          >
            <el-radio-button
              v-for="(item, index) in tableConfig.tabBarConfig.items"
              :key="index"
              :disabled="item.disabled"
              :label="item.label"
              ><i :class="item.icon"></i>{{ item.label
              }}<span v-if="item.num">({{ item.num }})</span></el-radio-button
            >
          </el-radio-group>
        </div>
      </template>
    </div>
    <!-- 列表 -->
    <el-table-bar :fixed="true" :bottom="35">
      <el-table
        border
        :data="tableData"
        highlight-current-row
        ref="table"
        @current-change="selectCurRow"
        v-loading="tableConfig.loading"
        @selection-change="selsChange"
        @select="selectCheckbox"
        @cell-click="cellClick"
        :size="tableConfig.size"
        :height="tableConfig.height"
        :max-height="tableConfig.maxHeight"
        :stripe="tableConfig.stripe"
        :fit="tableConfig.fit"
        :current-row-key="tableConfig.currentRowKey"
        :row-class-name="tableConfig.rowClassName"
        :row-style="tableConfig.rowStyle"
        :cell-class-name="tableConfig.cellClassName"
        :cell-style="tableConfig.cellStyle"
        :empty-text="tableConfig.emptyText || '暂无数据'"
        :default-sort="tableConfig.defaultSort"
        :tooltip-effect="tableConfig.tooltipEffect"
        :show-summary="tableConfig.showSummary"
        :sum-text="tableConfig.sumText"
        :summary-method="tableConfig.summaryMethod"
        :span-method="tableConfig.spanMethod"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          :width="tableConfig.showSummary ? 80 : 50"
          align="center"
          v-if="tableConfig.showSelection"
        >
        </el-table-column>

        <el-table-column
          type="index"
          width="80"
          align="center"
          v-if="tableConfig.showIndex"
        >
        </el-table-column>

        <el-table-column
          v-for="(col, index) in tableConfig.column"
          :prop="col.prop"
          :width="col.width"
          :min-width="col.minWidth || '110'"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.showTooltip"
          :align="col.align || 'center'"
          :key="index"
          :label="col.label"
          :sortable="col.sortable || true"
          :class-name="col.className"
          :label-class-name="col.lableClassName"
        >
          <template slot-scope="scope">
            <!-- 需要格式化内容 -->
            <!-- slot -->
            <template v-if="col.slot">
              <slot :row="scope.row" :name="col.prop"></slot>
            </template>

            <template v-else>
              <template v-if="col.formatter">
                <template v-if="col.type === 'tag'">
                  <template v-if="Array.isArray(scope.row[col.prop])">
                    <el-tag
                      v-for="(tagItem, tagIndex) in scope.row[col.prop]"
                      :key="tagIndex"
                      >{{ tagItem }}</el-tag
                    >
                  </template>
                  <template v-else>
                    <!-- 带不同颜色的tag 格式：值-colorType -->
                    <el-tag
                      v-html="
                        col
                          .formatter(scope.row[col.prop], scope.row, col)
                          .split('-')[0]
                      "
                      :type="
                        col
                          .formatter(scope.row[col.prop], scope.row, col)
                          .split('-')[1]
                      "
                    ></el-tag>
                  </template>
                </template>

                <span
                  v-else
                  v-html="col.formatter(scope.row[col.prop], scope.row, col)"
                ></span>
              </template>

              <!-- 不需要格式化内容 -->
              <template v-else>
                <span>{{ scope.row[col.prop] }}</span>
              </template>
            </template>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column
          label="操作"
          :width="tableConfig.operate.width"
          v-if="tableConfig.showOperate"
          :align="tableConfig.operate.align"
        >
          <template slot-scope="scope">
            <template
              v-for="(operateItem, operateIndex) in tableConfig.operate.options"
            >
              <template v-if="operateItem.slot">
                <slot :row="scope.row" :name="operateItem.prop"></slot>
              </template>
              <template v-else>
                <el-button
                  :key="operateIndex"
                  v-no-more-click
                  :size="operateItem.size"
                  :type="operateItem.type"
                  @click="operateEvent(operateItem.event, scope.row)"
                  >{{ operateItem.name }}</el-button
                >
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-table-bar>

    <!-- 底部分页 -->
    <el-col :span="24" class="toolbar" v-if="tableConfig.showPage">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="currentChange"
        @size-change="sizeChange"
        :page-sizes="pageConfig.pageSizes"
        :page-size="pageConfig.pageSize"
        :current-page="pageConfig.pageIndex"
        :total="pageConfig.total"
        style="float: right"
      >
      </el-pagination>
    </el-col>
  </div>
</template>
<script>
import toolBar from "../Toolbar";
import { splitStr, blurFormatter, fixedTableHeader } from "/util/util";
export default {
  name: "twTable",
  components: { toolBar },
  data() {
    return {
      search: {},
      showMoreSearch: false,
      tabsLabel:
        this.tableConfig.tabBarConfig &&
        this.tableConfig.tabBarConfig.defaultSelect
          ? this.tableConfig.tabBarConfig.items[0].label
          : "",
    };
  },

  props: {
    filters: {
      type: Object,
      default() {
        return {};
      },
    },
    searchData: {
      type: Object,
    },
    buttonList: {
      type: Array,
    },
    tableData: {
      type: Array,
    },
    tableConfig: {
      type: Object,
    },
    pageConfig: {
      type: Object,
    },
  },

  mounted() {
    this.outTableEle();
  },

  watch: {
    search: {
      handler(n, o) {
        this.$emit("searchChange", n);
      },
      deep: true,
    },
    tableData: {
      handler(n, o) {
        this.$nextTick(() => {
          let scrollView = document.querySelector(".scrollView");
          fixedTableHeader(scrollView, false);
        });
      },
      deep: true,
    },
  },

  methods: {
    blurFormatter,
    callFunction(item) {
      this.$emit("btnCallFunction", item);
    },
    resetBtn() {
      this.$emit("resetBtn", "");
      this.search = {};
    },

    // 抛出table元素
    outTableEle() {
      this.$emit("getTableEle", this.$refs.table);
    },

    // 多选
    selsChange: function (sels) {
      this.$emit("handleSelsChange", sels);
    },

    // 选择多选框
    selectCheckbox(sel, row) {
      this.$emit("handleSelectCheckbox", sel, row);
    },

    // 选择当前行
    selectCurRow(val) {
      this.$emit("selectCurrentRow", val);
    },

    currentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    //分页事件
    sizeChange(val) {
      this.$emit("handleSizeChange", val);
    },

    // 操作按钮事件
    operateEvent(event, val) {
      this.$emit("handleOperateEvent", event, val);
    },

    // 单元格点击事件
    cellClick(row, column, cell, event) {
      this.$emit("handleCellClick", row, column, cell, event);
    },

    // input 搜索框值改变事件
    inputChange(val, item) {
      const s = [",", ";", "'"];
      let m = s.filter((res) => {
        return val === res;
      });
      if (m.length || val.includes("'")) {
        val = "";
      }
      let v = splitStr(val);
      this.$set(this.search, item.key, v);
    },

    // tab栏点击事件
    tabsHandleClick(tab, event) {
      this.tabsLabel = typeof tab === "string" ? tab : tab.label;
      this.$emit("handleTabsClick", this.tabsLabel);
    },
  },
};
</script>

<style lang="less" scoped>
.table-components {
  padding-right: 10px;
}
.re90 {
  transform: rotateZ(90deg);
  transition: all 0.5s;
}
.re0 {
  transform: rotateZ(0deg);
  transition: all 0.5s;
}
.paginationFixed {
  z-index: 100;
}
.customitem .el-form-item {
  margin-bottom: 8px;
}
</style>

<style lang="less" scoped>
// ---------- 配置说明 ---------
// tableConfig: {
//   showSelection: true,   // 显示多选框
//   showRadio: true,       // 显示单选框
//   showIndex: false,      // 显示序号
//   loading: false,        // 显示loading状态
//   showPage: true,        // 显示分页
//   size: "medium",        // table的尺寸  medium / small / mini
//   showOperate: false,    // 显示操作栏
//   showTabBar: true,      // 显示Tab栏
//   tabBarConfig:{         // Tab栏配置
//     tabType: 'radio',    // Tab 的类型 radio or tab
//     type: 'card',        // el-tab的类型  radio无需加这项
//     defaultSelect: false,// 是否默认选中第一个tab
//     items: [             // 每个tab的配置
//       {
//         label: '北京',         // label标识
//         icon: 'el-icon-date',  // 图标
//         disabled: false,       // 是否禁用
//         num: 1                 // 数量
//       },
//       {
//         label: '上海',
//         icon: 'el-icon-date',
//         disabled: true,
//         num: 5
//       }
//     ]
//   },
//   operate: {
//     // 表格操作配置
//   },
//   column: [
//     // 表格列配置
//     {
//       label: "箱规",
//       align: "center",
//       sortable: true,
//       formatter: function (val, row) {
//         return row.boxLength + "*" + row.boxWidth + "*" + row.boxHeight;
//       },
//     },
//     {
//       prop: "boxCount",
//       label: "箱数",
//       align: "center",
//       sortable: true,
//     },
//   ],
// }
</style>